'use client';

import { ReactNode } from 'react';
import { UICarouselNavigationButton } from '@headless-workspace/core-ui';
import { GlowProductTileSkeleton, GlowSkeleton } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ArrayHelpers, FunctionHelpers } from '@headless-workspace/utils';

const NUMBER_OF_PRODUCT_TILE = 5;

type ProductCarouselSkeletonProps = {
    navigationButtonClassName?: string;
};

export const ProductCarouselSkeleton: Component<ProductCarouselSkeletonProps> = ({
    navigationButtonClassName,
}): ReactNode => {
    const items = ArrayHelpers.createSequentialArray(NUMBER_OF_PRODUCT_TILE);

    return (
        <div className={'flex flex-row items-center gap-1 h-full'} aria-hidden={true}>
            <UICarouselNavigationButton
                type={'prev'}
                onClick={FunctionHelpers.emptyFn}
                disabled={true}
                className={navigationButtonClassName}
            />
            <section className={'flex flex-col gap-1 overflow-hidden'}>
                <div className={'w-full m-auto overflow-hidden relative'} role={'group'}>
                    <ul className={'flex flex-row gap-1 touch-pan-y touch-pinch-zoom'}>
                        {items.map((item) => {
                            return (
                                <li
                                    key={`carousel-skeleton-item-${item}`}
                                    className={'first:ml-1 last:mr-1 first:desktop:ml-0 last:desktop:mr-0'}
                                >
                                    <GlowProductTileSkeleton />
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className={'px-1 desktop:px-0'}>
                    <GlowSkeleton
                        height={'0.25rem'}
                        containerClassName={'rounded-infinity h-carouselSlider justify-center'}
                    />
                </div>
            </section>
            <UICarouselNavigationButton
                type={'next'}
                onClick={FunctionHelpers.emptyFn}
                disabled={true}
                className={navigationButtonClassName}
            />
        </div>
    );
};
